import React, { useRef } from 'react';
import Table from 'cccisd-table';
import copy from 'copy-to-clipboard';
import notification from 'cccisd-notification';
import Modal from 'cccisd-modal';
import Tooltip from 'cccisd-tooltip';
import classnames from 'classnames';
import style from './style.css';
import IconLink from 'cccisd-icons/link';
import IconEdit from 'cccisd-icons/pencil5';
import DeploymentEdit from './DeploymentEdit';

const Boilerplate = window.cccisd.boilerplate;

const OpenLinksTable = ({ deployments, onSuccess }) => {
    const copyLinkRef = useRef(null);
    const editModalRefs = useRef({});
    const tableData = deployments.map(row => ({
        ...row,
        siteName: row?.settings?.siteName || '',
    }));

    const copyLink = surveyUrl => {
        copy(Boilerplate.url(surveyUrl));
        notification({
            message: 'Survey link copied successfully!',
            type: 'success',
            duration: 8000,
        });
    };

    const copySurveyUrl = row => {
        const surveyUrl = `/survey/${row.endpoint}`;

        return (
            <Modal
                ref={copyLinkRef}
                size="medium"
                trigger={
                    <Tooltip title="Copy Survey Link">
                        <button type="button" className={classnames('btn', 'btn-sm', 'btn-success')}>
                            <IconLink />
                        </button>
                    </Tooltip>
                }
                title="Copy Survey Link"
            >
                <div>
                    <div>
                        <span>{Boilerplate.url(surveyUrl)}</span>
                    </div>
                    <br />
                    <div>
                        <button
                            type="button"
                            onClick={() => {
                                copyLink(surveyUrl);
                            }}
                            className={classnames('btn', 'btn-warning')}
                        >
                            <span>Copy survey link</span>
                        </button>
                    </div>
                </div>
            </Modal>
        );
    };

    const getOpenTableColumns = () => {
        return [
            {
                handle: 'actions',
                label: 'Actions',
                name: 'actions',
                hideInCsv: true,
                render: (value, row) => {
                    return (
                        <div className={style.actionButtons}>
                            {copySurveyUrl(row)}
                            <Modal
                                ref={modalInstance => {
                                    editModalRefs.current[row.deploymentId] = modalInstance;
                                }}
                                size="small"
                                trigger={
                                    <Tooltip title="Edit Link Details">
                                        <button type="button" className={`btn btn-sm btn-warning ${style.spaceLeft}`}>
                                            <IconEdit />
                                        </button>
                                    </Tooltip>
                                }
                                title={`${row.settings.siteName} - ${row.label}`}
                            >
                                <DeploymentEdit
                                    row={row}
                                    closeModal={() =>
                                        editModalRefs.current[row.deploymentId] &&
                                        editModalRefs.current[row.deploymentId].close()
                                    }
                                    onSuccess={onSuccess}
                                />
                            </Modal>
                        </div>
                    );
                },
                renderCSV: (value, row) => {
                    const surveyUrl = `/survey/${row.endpoint}`;
                    return Boilerplate.url(surveyUrl);
                },
            },
            {
                handle: 'siteName',
                label: 'Site Name',
                name: 'siteName',
                className: 'text-center',
                sort: true,
                filter: true,
                filterSettings: {
                    type: 'text',
                    field: 'siteName',
                },
                render: (value, row) => {
                    return (
                        <div>
                            <p>{row.settings.siteName}</p>
                        </div>
                    );
                },
            },
            {
                handle: 'label',
                label: 'Collection Details',
                name: 'label',
                sort: true,
                filter: true,
            },
            {
                handle: 'openDate',
                label: 'Open Date',
                name: 'opensAt',
                sort: true,
                filter: true,
                filterSettings: {
                    type: 'date',
                },
                render: (value, row) => {
                    const localDate = row.opensAt && new Date(row.opensAt).toLocaleString();
                    return (
                        <div>
                            <p>{localDate}</p>
                        </div>
                    );
                },
            },
            {
                handle: 'closeDate',
                label: 'Close Date',
                name: 'closesAt',
                sort: true,
                filter: true,
                filterSettings: {
                    type: 'date',
                },
                render: (value, row) => {
                    const localDate = row.closesAt && new Date(row.closesAt).toLocaleString();
                    return (
                        <div>
                            <p>{localDate}</p>
                        </div>
                    );
                },
            },
            {
                handle: 'completedResponses',
                label: 'Completion Rate',
                name: 'completedResponses',
                sort: true,
                filter: true,
                render: (value, row) => {
                    return (
                        <div>
                            <p>
                                {row.completedResponses} out of {row.totalResponses}
                            </p>
                        </div>
                    );
                },
            },
        ];
    };

    return (
        <div>
            <h3>Open Links</h3>
            <Table
                rowKey="deploymentId"
                name="open-links-table"
                columns={getOpenTableColumns()}
                data={tableData}
                showPerPageOptions
                perPageOptions={[10, 25, 50, 100]}
                perPage={10}
                isCsvDownload
                csvFilename="open_links.csv"
            />
        </div>
    );
};

export default OpenLinksTable;
